import { CampaignFormData, AGE_OPTIONS, AdgroupFormData } from '@tt4b/ttam-enums';
import { computed, Ref, ref } from '@vue/composition-api';
import { useAudienceSelected } from '../audience/hooks';
import { i18n } from './../../../i18n';
import { useStdObjectiveType, useStdAdgroupIs, useValidateU18 } from '@tt4b/ttam-hooks';

export function useIsSelectedIndustryType(opt: { campaignData: Ref<CampaignFormData> }) {
  const { campaignData } = opt;
  const isSelectedIndustryType = computed(() => Boolean(campaignData.value.industryTypes?.length));
  return {
    isSelectedIndustryType,
  };
}

export function useAgeDisabled(opt: { campaignData: Ref<CampaignFormData>; adgroupData: Ref<AdgroupFormData> }) {
  const { campaignData, adgroupData } = opt;
  const { isSelectedIndustryType } = useIsSelectedIndustryType({ campaignData });
  const { isSelectPremiumAge } = useAudienceSelected({ adgroupData });
  const disableStatus = computed(() => {
    if (isSelectPremiumAge.value) {
      return {
        disabled: true,
        tips: i18n.t('module_targeting_age_with_premuim_hint'),
      };
    }
    return {
      disabled: isSelectedIndustryType.value,
    };
  });

  const { isLeadAds } = useStdObjectiveType({ campaignFormData: campaignData });
  const { isPSA } = useStdAdgroupIs({ campaignFormData: campaignData, adgroupFormData: adgroupData });
  const { isCloseLoopOnlyUs } = useValidateU18({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });

  const ageOptions = computed(() => {
    const options = AGE_OPTIONS().filter(item => {
      const isDisabledByIsLeadAds = item.disableLeadAds && isLeadAds.value;
      const isDisabledBySelectedIndustry = item.disableSelectedIndustry && isSelectedIndustryType.value;
      const isDiasbledPsa = item.disablePsa && isPSA.value;
      return !isDisabledByIsLeadAds && !isDisabledBySelectedIndustry && !isDiasbledPsa;
    });
    const option13to17 = options.find(({ value }) => value === '13,17');
    if (option13to17) {
      const isUnder18Disable =
        isCloseLoopOnlyUs.value &&
        // "13-17"没选中
        !adgroupData.value.age.find(item => item === '13,17');
      option13to17.disabled = isUnder18Disable;
    }

    return options;
  });

  return {
    disableStatus,
    ageOptions,
  };
}

export function useAgeName(opt: { age: Ref<string[]> }) {
  const { age } = opt;
  const ageMap = computed(() =>
    AGE_OPTIONS().reduce((pre, cur) => {
      pre[cur.value] = cur.name;
      return pre;
    }, {}),
  );
  const ageName = computed(() => age.value.map(item => ageMap.value[item] || ''));
  return {
    ageName,
  };
}

export function usePropsAgeLegalPromptVisible(opt: { age: Ref<string[]> }) {
  const { age } = opt;
  const [nolimitOption, specialOption] = AGE_OPTIONS();
  const isShowAgeLegalPrompt = computed(
    () => age.value?.includes(nolimitOption.value) || age.value?.includes(specialOption.value),
  );

  return {
    isShowAgeLegalPrompt,
  };
}
